import React from 'react';
import TextareaAutosize             from 'react-textarea-autosize';

export default function(props) {
    return (
        <TextareaAutosize {...props}/>
    )
}
